import i18n from "i18next";
import config from "./i18next-parser.config.js";
import { initReactI18next } from "react-i18next";
import dayjs from "dayjs";
import localizedFormat from "dayjs/plugin/localizedFormat"
import translationFR from './locales/fr/translation.json';
import translationEN from './locales/en/translation.json';
import translationDE from './locales/de/translation.json';
import translationES from './locales/es/translation.json';
import translationIT from './locales/it/translation.json';
import translationPT from './locales/pt/translation.json';
import 'dayjs/locale/fr'
import LanguageDetector from 'i18next-browser-languagedetector';

dayjs.locale("fr")
dayjs.extend(localizedFormat)

const resources = {
    fr: { 
        translation: translationFR
    },
    en: { 
        translation: translationEN
    },
    de: { 
        translation: translationDE
    },
    es: { 
        translation: translationES
    },
    it: { 
        translation: translationIT
    },
    pt: { 
        translation: translationPT
    },
}

const languageDetector = new LanguageDetector(null, {
    // order and from where user language should be detected
    order: ['querystring', 'htmlTag',  'navigator'],
  
  });

i18n.use(languageDetector)
    .use(initReactI18next)
    .init({
        resources,
        ...config
    });


export default i18n;